// extracted by mini-css-extract-plugin
module.exports = {"IconStyles":"Icon_IconStyles__2gRSl"};